/**
 * @author - steves165
 */

(function() {
    'use strict';

    /*global angular*/
    var module = angular.module('vhols');
        /**
         * Grabs list of hotels from cjs book api.
         */
        module.service('hotelsService', ['$http', '$interpolate', '$q', '$window', function($http, $interpolate, $q, $window) {
            var pathname = window.location.pathname;
            var generic = pathname.replace('-holidays', '');
            var locationName = generic.substr(generic.lastIndexOf('/') + 1 ,generic.length);

            var cleanHotelsDeDupe = function (resp) {
                if (resp && resp.data) {
                    var holidays = resp.data.holidays || [];

                    if (holidays.length !== 0) {
                        var collected = holidays.reduce(function(collector, next) {
                            var hotel = next.hotel;

                            if (hotel.content && (hotel.content.images && hotel.content.images.length > 0)) {
                                collector[hotel.id] = next;
                            }

                            return collector;
                        }, Object.create(null));

                        return Object.keys(collected).map(function(key) {
                            return collected[key];
                        });
                    }

                    return [];
                }
            };

            function getHotels() {
                if ($window.ngVariables.HOLIDAY_TYPES_ECMS_MAPPING != null) {
                    return $window.vhols.getHotels().then(cleanHotelsDeDupe);
                } else { // No hotels fetching for non-destination pages
                    return $q.resolve([]);
                }
            }

            return {
                getHotels: getHotels
            };
        }])

		.service('destinationsService', ["$http", "$interpolate", function($http, $interpolate) {
            var clean = function(resp) {
                return resp.data;
            };

            this.getPageProps = function(node, depth) {
                var propDepth = depth ? '?depth=' + depth : '';
                var url = '/.rest/nodes/v1/website' + node.replace('.html', '') + '/events' + propDepth;

                return $http({
                    method: "GET",
                    url: url,
                    cache: true
                }).then(clean);
            };

            this.getLocationData = function(params) {
                var path = $interpolate("/locations-public-api/search/location?brand={{businessContext}}&locationId={{locationId}}&bookingType={{bookingType}}");
                var url = path({
                    businessContext: params.businessContext,
                    locationId: params.locationId,
                    bookingType: params.bookingType
                });

                return $http.get(url, {
					cache: true
				});
            };
        }])

        .service('deviceDetection', function() {
            var PHONE = 767,
                TABLET = 991;

            function getDevice(size) {
                var width = size || window.screen.width;

                if (width < PHONE) {
                    return 'Phone';
                } else if (width >= PHONE && width < TABLET) {
                    return 'Tablet';
                } else {
                    return 'Desktop';
                }
            }

            return {
                getDevice: getDevice
            };
        })

        .service('excursionsService', ["$http", function($http) {

            var url = '/content-api/v2/location/metadata/v1/excursions/1/';

            var clean = function (resp) {
                return resp.data.values || [];
            };

            function getExcursions(locationId, brandId) {
                var apiUrl = url + brandId + '/' + locationId;
                return $http.get(apiUrl, {cache: true}).then(clean);
            }

            return {
                getExcursions: getExcursions
            };
        }]);
})();
